<div class="app-container responsive-container">

  <div class="call-history-list-filter-panel">
    <cc-direction-filter [filters]="filters"></cc-direction-filter>
    <cc-call-numbers-filter
      [msisdns]="msisdns"
      [allNumbersSelected]="allNumbersSelected"
      (toggleSelectAll)="toggleAllNumbersSelect()">
    </cc-call-numbers-filter>
    <cc-users-filter [users]="users"
                     [label]="'CALL_HISTORY.USERS' | translate"
                     [allUsersSelected]="allUsersSelected"
                     (toggleSelectAllUsers)="toggleAllUsersSelect()"
    ></cc-users-filter>
    <cc-date-filter
      [datePickerOpened]="datePickerOpened"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [startDate]="startDate"
      [endDate]="endDate"
      [opens]="opens"
      (change)="dateFilterChange($event)">
    </cc-date-filter>
  </div>
  <cc-all-missed-calls-filter></cc-all-missed-calls-filter>

  <cc-box>
    <div class="call-history-list-content" content box>
      <cc-search-filter></cc-search-filter>
      <cc-calls-table
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        (detailsClicked)="callsTableDetailsClicked()"
        [sort]="sort">
      </cc-calls-table>
      <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="total"
        [pageSize]="paginator.pageSize"
        (page)="addDisplayParams($event)"
      ></mat-paginator>
    </div>
  </cc-box>
</div>
